(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/joker-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/joker-utils.js');
"use strict";

var _svs$numbergames$rule;

const productMapping = svs.numbergames.productMapping;
const config = (_svs$numbergames$rule = svs.numbergames.rules.data) === null || _svs$numbergames$rule === void 0 ? void 0 : _svs$numbergames$rule.config;
const JOKER_WINPLAN_DATA = {
  2: 40,
  3: 80,
  4: 500,
  5: 10000,
  6: 100000,
  7: 10000000
};

const isNewRules = _ref => {
  var _config$joker$ruleCha, _config$joker;
  let {
    drawNumber,
    product
  } = _ref;
  if (!drawNumber || !product) {
    svs.numbergames.rules.logger.debug('Drawnumber or product is missing');
    return false;
  }
  const {
    ONSJOKER,
    LORJOKER
  } = (_config$joker$ruleCha = config === null || config === void 0 || (_config$joker = config.joker) === null || _config$joker === void 0 ? void 0 : _config$joker.ruleChange) !== null && _config$joker$ruleCha !== void 0 ? _config$joker$ruleCha : {};
  if (!ONSJOKER || !LORJOKER) {
    return false;
  }
  switch (true) {
    case productMapping.isJokerWednesday(product) && drawNumber >= ONSJOKER:
    case productMapping.isJokerSaturday(product) && drawNumber >= LORJOKER:
      return true;
    default:
      return false;
  }
};

function getJokerWinPlanData(jokerPrice) {
  return Object.fromEntries(Object.entries(JOKER_WINPLAN_DATA).map(_ref2 => {
    let [correct, amount] = _ref2;
    return [correct, amount * jokerPrice / 10];
  }));
}
Object.assign(svs.numbergames.rules.utils.joker, {
  isNewRules,
  getJokerWinPlanData
});

 })(window);